const closeButtonLabel = "Fermer";
const frLU = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  frLU as default
};
